import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../components/LoadingSmall.js';
import axios from 'axios';

class Popup extends React.Component {
    constructor(props) {
        super(props);

        this.language = {};
        this.language['norwegian'] = {
            title:'Nyhetsbrev abonnenter',
            description:'Ønsker du flere abonnenter til dine nyhetsbrev ?',
            details:'Med Crall kan du lage en "popup" som oppfordrer kundene til å melde seg på din nyhetsbrevliste. Dette er viktig for deg, og utrolig viktig for at du skal få mest mulig ut av Crall.',
            question:'Skal vi aktivere e-postinnsamleren?',
            button_accept:'Aktiver',
            button_decline:'Nei takk',
        }

        this.language['english'] = {
            title:'Nyhetsbrev abonnenter',
            description:'Ønsker du flere abonnenter til dine nyhetsbrev ?',
            details:'Med Crall kan du lage en "popup" som oppfordrer kundene til å melde seg på din nyhetsbrevliste. Dette er viktig for deg, og utrolig viktig for at du skal få mest mulig ut av Crall.',
            question:'Skal vi aktivere e-postinnsamleren?',
            button_accept:'Aktiver',
            button_decline:'Nei takk',
        }

        this.state = {
            error:false,
            info:false,
            isLoading:false,
        }


        this.accept = this.accept.bind(this);
       
    }

    accept() {
        this.setState({isLoading:true});
        axios.get('/ajax/setup_copy_popup?l='+this.props.language).then(res => {
            this.setState({isLoading:false});
            this.props.handleComplete();
        });
    }


    getLanguage(str) {
        return this.language[this.props.language][str];
    }
   
    render() {
        return (
            <div>
                <h1>{this.getLanguage('title')}</h1>
                <span className="description">{this.getLanguage('description')}</span>

                <div className="m-t-20">
                     {this.getLanguage('details')}<br/><br/>
                     <strong>{this.getLanguage('question')}</strong>
                </div>

                {this.state.isLoading ?
                <div className="m-t-20 col-sm-12 text-center">
                    <LoadingSmall />
                </div>
                :
                <div className="m-t-40 col-sm-12 text-center">
                    {this.state.isLoading ? 
                        <LoadingSmall />
                    :<div>
                        <button className="btn btn-dark btn-lg btn-outline m-r-10" onClick={this.props.handleComplete} type="button"><i className="icon wb-close"></i> {this.getLanguage('button_decline')}</button>
                        <button className="btn btn-dark btn-lg" onClick={this.accept} type="button"><i className="icon wb-check"></i> {this.getLanguage('button_accept')}</button>
                    </div>
                    }
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({

});

export default Popup;



// WEBPACK FOOTER //
// ./containers/setup/Popup.js